<script setup>
import { router, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { UserRoundCog, X } from 'lucide-vue-next'

const page = usePage()
const impersonate = computed(() => page.props.impersonate)
const currentUser = computed(() => page.props.auth?.user)

const stopImpersonating = () => {
  router.post('/impersonate/stop')
}
</script>

<template>
  <div
    v-if="impersonate?.active"
    class="bg-purple-600 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium z-50 relative"
  >
    <UserRoundCog class="h-4 w-4 shrink-0" />
    <span>
      Impersonating <strong>{{ currentUser?.name }}</strong>
      <template v-if="impersonate.original_user">
        &mdash; Return to {{ impersonate.original_user.name }}
      </template>
    </span>
    <button
      @click="stopImpersonating"
      class="ml-2 inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded-full px-3 py-0.5 text-xs font-semibold transition-colors"
    >
      <X class="h-3 w-3" />
      Stop
    </button>
  </div>
</template>
